import React from "react";
import { Updater, useImmer } from "use-immer";

import { IgToggleButtonGroup } from "@intelligems/ig-theme";
import { StripeInterval, SubscriptionInterval } from "@intelligems/ig-types";
import { ToggleButton } from "@mui/material";

const buttons = [
  <ToggleButton
    value="month"
    key="monthly"
    size={"small"}
    sx={{
      borderBottomLeftRadius: 9999,
      borderTopLeftRadius: 9999,
      paddingLeft: "12px",
      fontSize: "12px",
    }}
  >
    Monthly
  </ToggleButton>,
  <ToggleButton
    value="year"
    key="yearly"
    size={"small"}
    sx={{
      borderBottomRightRadius: 9999,
      borderTopRightRadius: 9999,
      paddingRight: "12px",
      fontSize: "12px",
    }}
  >
    Annual
  </ToggleButton>,
];

interface BillingHeaderProps {
  billingInterval: StripeInterval;
  setBillingInterval: Updater<StripeInterval>;
}

export const BillingIntervalToggleGroup = ({
  billingInterval,
  setBillingInterval,
}: BillingHeaderProps) => {
  return (
    <IgToggleButtonGroup
      buttons={buttons}
      value={billingInterval}
      control={{
        exclusive: true,
        onChange: (event, value: StripeInterval) => {
          if (value) {
            setBillingInterval(value);
          }
        },
      }}
    />
  );
};
